import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Subject, Observable } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { EngineState } from 'src/app/engine/state/engine.state';
import { BdGraph } from 'src/lib/graph/graph.model';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { NodeState } from 'src/app/engine/state/nodes/engine.nodes.state.model';

export enum TreeTheme {
  Light = 'light',
  Dark = 'dark',
  Themed= 'themed'
}

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnInit, OnDestroy {
  @Select(EngineState.getViewGraph)
  viewGraph$: Observable<BdGraph<ViewTreeNode>>;

  @Input()
  theme = TreeTheme.Dark;

  @Input()
  searchGraph: BdGraph<ViewTreeNode>;

  private ngUnsubscribe = new Subject();

  constructor(
    private store: Store,
    private graphService: BdGraphService
  ) { }

  ngOnInit() {
    // When the user selects a single structure, automatically scroll that structure into view
    // Note: as of 04/16/2019 this is only support by Chrome and Firefox
    this.store.select(EngineNodesState.getCheckedNodes)
      .pipe(
        // filter(nodes => nodes !== undefined),
        filter(nodes => nodes.length === 1),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(node => {
        setTimeout(() => {
          this.scrollNodeIntoView(node[0]);
        });
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  scrollNodeIntoView(node: NodeState) {

    const sanitizedID = this.graphService.sanitizeNodeID(node.objectId);
    const target = <HTMLDivElement>document.querySelector(`[data-id=${sanitizedID}]`);

    if (!target) {
      return;
    }

    // Manual check to see if the browser support smooth scrolling.
    // Although Safari supports scrollIntoView, it only has limited support via the boolean operator.
    // More importantly, the scrolled column jumps position when the mouse hovers over it.
    // For this reason we're not support Safari until Apple gets their act together.
    const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
    if (isSmoothScrollSupported) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }

}
